/**
 * Key Numbers 5007 — KUK learning highlights.
 *
 * The gradient band of headline figures: a large number over its label. Sibling
 * of Key Numbers 5006 (same grid, same rules) leading with a figure instead of an
 * icon. Ported from kuk-campus-portal's `components/Degree/Highlights.tsx`.
 *
 * Every field maps to a column that already exists on `key_numbers` — the
 * variant adds no schema of its own beyond widening `key_numbers.variant`.
 */

export const KEY_NUMBERS_5007_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Highlights",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_title: "",
    meta_description: "",
    meta_priority: 1,
    meta_status: true,
  },

  KEY_NUMBERS_FIELDS_CONFIG: [
    {
      fieldName: "gradient_color_1",
      label: "Band gradient — start",
      value: "#C5839F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#C5839F",
      description: "Set BOTH stops for a gradient; leave either empty to use the flat background colour below.",
      required: false,
      defaultValue: "#C5839F",
    },
    {
      fieldName: "gradient_color_2",
      label: "Band gradient — end",
      value: "#9C4638",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#9C4638",
      required: false,
      defaultValue: "#9C4638",
    },
    {
      fieldName: "background_color",
      label: "Band background (fallback)",
      value: "#9C4638",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#9C4638",
      required: false,
      defaultValue: "#9C4638",
    },
    {
      fieldName: "title_start_color",
      label: "Figure colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "description_color",
      label: "Label colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_4",
      label: "Divider colour",
      value: "rgba(255, 255, 255, 0.10)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(255, 255, 255, 0.10)",
      required: false,
      defaultValue: "rgba(255, 255, 255, 0.10)",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Figure",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 100+",
      defaultValue: "",
    },
    {
      header: "Label",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Live Lectures",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
